// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  SelectInput,
  createDataWithOffices,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const FinancialBillsToPayPage = ({
  offices,
  history,
  createData,
  validation,
  suppliers,
  selectedOffice,
  setSelectedOffice,
}) => {
  return (
    <PageWrapper title={'Contas a Pagar'}>
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="officeInput" className="form-label">
                        Escritório
                      </Label>
                      <SelectInput
                        isClearable
                        className="form-control"
                        inputId="officeInput"
                        value={selectedOffice}
                        onChange={(eventInput) => {
                          if (eventInput) {
                            setSelectedOffice(eventInput);
                          } else {
                            setSelectedOffice('');
                          }
                        }}
                        options={createDataWithOffices(offices)}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>

                  <Col md={4} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="supplierInput" className="form-label">
                        Fornecedor
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="supplierInput"
                        value={validation.values.supplierInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'supplierInput',
                                value: '',
                              },
                            });
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'supplierInput',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'supplierInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(suppliers)}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-3"
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary ">
                      Consultar
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
